import { Component, Input } from "@angular/core";
import { SvgIconComponent } from "../svg-icon/svg-icon.component";
import { NgStyle } from "@angular/common";

@Component({
  selector: 'app-spinner-loader',
  standalone: true,
  imports: [
    SvgIconComponent,
    NgStyle
  ],
  templateUrl: './spinner-loader.component.html',
  styleUrl: './spinner-loader.component.scss'
})
export class SpinnerLoaderComponent {
  @Input() spinnerStyle: Object = {};

  get mergedSpinnerStyle() {
    return {
      ...this.spinnerStyle,
      height: '24px',
      width: '24px',
      backgroundColor: '#1062B9'
    };
  }

}
